import { useEffect, useState } from "react";
import { fetchProfile } from "./../services/api/profileService";

export default function ProfilePage() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    try {
      const data = await fetchProfile();
      setProfile(data);
    } catch (error) {
      console.error("Profile fetch failed", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="p-6 text-center text-gray-500">
        Loading profile...
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto p-6">
      <div className="bg-white rounded-2xl shadow-lg overflow-hidden">

        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 h-32"></div>

        {/* Profile Content */}
        <div className="p-6 relative">

          {/* Avatar */}
          <div className="-mt-16 flex items-center gap-6">
            <img
              src={
                profile?.avatar
                  ? profile.avatar
                  : `https://ui-avatars.com/api/?name=${profile?.name || "User"}&background=2563eb&color=fff&size=120`
              }
              alt="Profile"
              onError={(e) => {
                e.target.src = `https://ui-avatars.com/api/?name=${profile?.name || "User"}&background=2563eb&color=fff&size=120`;
              }}
              className="w-28 h-28 rounded-full border-4 border-white shadow-md object-cover"
            />

            <div>
              <h2 className="text-2xl font-bold">{profile?.name || "N/A"}</h2>
              <p className="text-gray-500">{profile?.designation || "N/A"}</p>
              <span className="inline-block mt-2 px-3 py-1 text-sm bg-green-100 text-green-700 rounded-full">
                {profile?.role || "User"}
              </span>
            </div>
          </div>

          {/* Details */}
          <div className="grid md:grid-cols-2 gap-6 mt-8">

            <div className="bg-gray-50 p-4 rounded-xl">
              <h3 className="font-semibold mb-3 text-gray-700">Personal Info</h3>
              <p><strong>Email:</strong> {profile?.email || "N/A"}</p>
              <p><strong>Phone:</strong> {profile?.phone || "N/A"}</p>
              <p><strong>Employee ID:</strong> {profile?.employee_id || "N/A"}</p>
            </div>

            <div className="bg-gray-50 p-4 rounded-xl">
              <h3 className="font-semibold mb-3 text-gray-700">Work Info</h3>
              <p><strong>Department:</strong> {profile?.department || "N/A"}</p>
              <p><strong>Designation:</strong> {profile?.designation || "N/A"}</p>
              <p><strong>Joined:</strong> {profile?.created_at || "N/A"}</p>
            </div>

          </div>

          {/* Edit Button */}
          <div className="mt-6 text-right">
            <button className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
              Edit Profile
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}